module.exports = __webpack_public_path__ + "img/big.6732959d.jpg";